import { render, staticRenderFns } from "./ItemListDeleteLayout.vue?vue&type=template&id=26a54756&scoped=true&"
import script from "./ItemListDeleteLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListDeleteLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a54756",
  null
  
)

export default component.exports